import React from "react";
import classes from "./CheckoutModal.module.css";
import { useDispatch, useSelector } from "react-redux";
import { FaTimes } from "react-icons/fa";
import { TbFaceIdError } from "react-icons/tb";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { closeNotification } from "../../features/notifications/notificationSlice";
import {
  NOTIFICATIONTYPES,
  NOTIFICATIONMESSAGES,
} from "../../constants/GeneralConstants";

const NotificationModal = () => {
  const dispatch = useDispatch();
  const {
    notificationType,
    notificationMessage,
    notificationOpen: isModalOpen,
  } = useSelector((state) => state.notifications);

  const isErrorNotification = notificationType === NOTIFICATIONTYPES.error;
  const isSuccessNotification = notificationType === NOTIFICATIONTYPES.success;

  return (
    isModalOpen && (
      <div className={classes.background}>
        <div className={classes.container}>
          <FaTimes
            className={classes.closeIcon}
            onClick={() => dispatch(closeNotification())}
          />
          <div className={classes.messageContainer}>
            <h3>Paldies par jūsu pasūtījumu!</h3>
            <div>{notificationMessage}</div>
            {/* <div>Ir notikusi kļūda, atvainojamies par neērtībām!</div> */}
            {isErrorNotification && (
              <TbFaceIdError className={classes.notificationIcon} />
            )}
            {isSuccessNotification && (
              <AiOutlineCheckCircle
                className={`${classes.notificationIcon} ${classes.successIcon}`}
              />
            )}
          </div>
        </div>
      </div>
    )
  );
};

export default NotificationModal;